import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface SalesReturnReasonParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SalesReturnReason {
    id?: any;
    name:string;
}


export abstract class SalesReturnReasonData {

    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<SalesReturnReason[]>;
    abstract create(url: string, data: SalesReturnReason): Observable<SalesReturnReason[]>;
    abstract update(url: string, data: SalesReturnReason): Observable<SalesReturnReason>;
    abstract delete(url: string): Observable<any>;
}
